import { useEffect, useState } from 'react';
import { Zap } from 'lucide-react';

// Live countdown to the ₹5 speed bonus (deadline counted from when the shop marked the order ready).
export default function SpeedBonusTimer({ task }) {
  const deadline = task.ready_at ? new Date(task.ready_at).getTime() + (task.speed_bonus_deadline_sec || 1200) * 1000 : null;
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  if (!deadline) return null;
  const left = Math.max(0, Math.floor((deadline - now) / 1000));
  const live = left > 0;
  const mm = String(Math.floor(left / 60)).padStart(2, '0');
  const ss = String(left % 60).padStart(2, '0');
  return (
    <div data-testid={`fleet-speed-bonus-${task.id}`}
      className={`mt-3 rounded-lg px-3 py-2 flex items-center gap-2 text-sm font-bold ${live ? 'bg-[#FFF3E0] text-[#9A4500]' : 'bg-muted text-ink/50'}`}>
      <Zap className="w-4 h-4 shrink-0"/>
      {live ? (
        <span>Deliver in <span data-testid={`fleet-speed-bonus-time-${task.id}`} className="tabular-nums font-black">{mm}:{ss}</span> for a +₹5 speed bonus</span>
      ) : <span>Speed bonus window closed — regular fare applies</span>}
    </div>
  );
}
